/**
 * İşlem bazlı yetki matrisi — prototipteki `PERM` sabiti birebir (03- §2: PM süper kullanıcı).
 * Prototip rolleri → kanonik rol: erdem=saha_inspektoru, mutlu=formen, ensari=saha_supervizoru,
 * mustafa=kalite_lideri, bahadir=pm. Sistem yöneticisi PM gibi her işlemde yetkili (kurulum dönemi).
 */
export const YETKI = {
    dogrula: ["saha_inspektoru"],
    rapor: ["saha_inspektoru"],
    evrak: ["saha_inspektoru"],
    ndtYukle: ["saha_inspektoru"],
    fail: ["saha_inspektoru"],
    planla: ["formen", "saha_supervizoru"],
    adim: ["formen", "saha_supervizoru"],
    /** D-031: kapı olmayan adımı "No record available" ile atlamak; kapı adımı için `kayitYokKapi`. */
    kayitYok: ["formen", "saha_supervizoru", "kalite_lideri"],
    kayitYokKapi: ["kalite_lideri"],
    talep: ["formen", "saha_supervizoru", "pm"],
    fitupHazir: ["formen", "saha_supervizoru"],
    fitupGir: ["saha_inspektoru", "kalite_lideri"],
    release: ["saha_inspektoru", "kalite_lideri"],
    weld: ["formen"],
    /** D-029: doldurulmuş weld map PDF'i kalite imzalarını da taşır; formen ya da kalite lideri yükler (fit-up release'inden sonra). */
    weldMapPdf: ["formen", "kalite_lideri"],
    pwhtKapat: ["kalite_lideri"],
    kapat: ["kalite_lideri"],
    assembly: ["saha_supervizoru", "formen"],
    imza: ["kalite_lideri"],
    teslim: ["formen", "saha_supervizoru"],
    sokum: ["formen", "saha_supervizoru"],
    saha: ["formen", "saha_supervizoru"],
    batch: ["pm"],
    mrb: ["kalite_lideri"],
    /** D-040: repair planlamadaki bulguyu Inspection verification'a geri göndermek (kalite lideri; PM ve sistem yöneticisi her zaman). */
    geriGonder: ["kalite_lideri"],
    /** D-035: kesim planını onaylamak (triyajda kesim rotalı kalemi göndermek, komponent sayfasında "Approve cut plan"). Bekir 30.09.2026: yalnız kalite lideri; PM ve sistem yöneticisi her zaman. */
    kesimPlani: ["kalite_lideri"],
    /**
     * D-074 (U-073), K2: Documents sayfasından Registers belgesi dosyalamak (kalite lideri; PM ve sistem yöneticisi her zaman). Fiyatlı
     * belge (PO) yalnız PM ve sistem yöneticisi; kişisel belgeyi (WPQ, süreklilik, NDT sertifikası) kalite lideri yalnız kendi yüklediyse
     * dosyalar (`kutukDosyalayabilirMi`, belgeler.ts). Registers ekranının kendisi PM ve sistem yöneticisinde kalır.
     */
    belgeKutuk: ["kalite_lideri"],
    /** D-074 (U-073), K3: belge uyarısını gerekçeyle kapatmak ("Mark reviewed") ve Word satırına karar vermek (kalite lideri; PM ve sistem yöneticisi her zaman). */
    belgeUyari: ["kalite_lideri"],
    /**
     * D-074 Faz 2 (plan §5.7, §5.15, K35): kimlik kararları (KIM-01, KIM-02, PB-01) ve kararı geri alma (kalite lideri; PM ve sistem
     * yöneticisi her zaman). Kalite liderine hidrotest ve NDT dosyalama yetkisi VERMEZ: kararla gelen dosyalama bu işlemle yapılır (karar
     * ekranı PR'ı); öbür dosyalama yetkileri (`evrak`, `ndtYukle`, `rapor`) değişmez. Saha inspektörü kutuyu görür, karar vermez.
     */
    belgeKimlikKarari: ["kalite_lideri"],
};
export function yetkiliMi(rol, islem) {
    if (rol === "pm" || rol === "sistem_yoneticisi")
        return true;
    return YETKI[islem].includes(rol);
}
/** Buton tooltip'i için: "Yetki: Formen / Saha Süpervizörü" */
export function yetkiMetni(islem, etiket) {
    return "Yetki: " + YETKI[islem].map(etiket).join(" / ");
}
//# sourceMappingURL=yetki.js.map